import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const PLAN_TYPES = [
  "Monthly Startup",
  "Monthly Investor",
  "Quarterly Startup",
  "Quarterly Investor",
  "Annual Startup",
  "Annual Investor",
  "Annual Corporate",
];
const Invoices = () => {
  const [plans, setPlans] = React.useState(null);
  const [plantype, setplantype] = useState("All");

  const navigate = useNavigate();
  const fetchStats = async () => {
    const { data } = await Axios({
      method: "get",
      url: "/api/activity/invoices",
    });
    setPlans(data.data);
  };
  React.useEffect(() => {
    fetchStats();
  }, []);
  if (plans === null) {
    return <CircularProgress />;
  }
  return (
    <>
      <div className="container admin-user-activity">
        <h3>
          Invoices (
          {
            plans.filter((lead) => {
              if (plantype === "All") return lead;
              else if (lead.plan === plantype) return lead;
            }).length
          }
          )
        </h3>
        <div className="">
          <select
            id="typeDropdown"
            className="h-40px"
            value={plantype}
            onChange={(e) => setplantype(e.target.value)}
          >
            <option value="All">All</option>
            {PLAN_TYPES.map((v, i) => {
              return (
                <option key={i} value={v}>
                  {v}
                </option>
              );
            })}
          </select>
        </div>
        {plans?.length > 0 ? (
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr className="plan_thead_tr plan_tr">
                <th className="plan_thead_tr plan_td"> User</th>
                <th className="plan_thead_tr plan_td">Plan</th>
                <th className="plan_thead_tr plan_td">Invoice Link</th>
                <th className="plan_thead_tr plan_td">SubscriptionID</th>
                <th className="plan_thead_tr plan_td">Subscribed at</th>
              </tr>
            </thead>
            <tbody className="plan_tbody">
              {plans
                .filter((lead) => {
                  if (plantype === "All") return lead;
                  else if (lead.plan === plantype) return lead;
                })
                .map((plan) => (
                  <tr key={plan._id} className="plan_tbody_tr plan_tr">
                    <td className="plan_tbody_td plan_td">
                      <div
                        onClick={() =>
                          navigate(
                            `/admin/user-activity?tab=13&userid=${plan.user?._id}`
                          )
                        }
                        className="d-flex plan_tbody_logo align-items-center pointer"
                      >
                        {plan.user ? (
                          <>
                            <img src={plan?.user?.avatar} alt="logo" />
                            <div>
                              <p className="m-0">
                                {plan?.user?.name
                                  ? plan?.user?.name
                                  : `${plan?.user?.firstname} ${plan?.user?.lastname}`}
                              </p>
                              <p className="m-0 mt-8">{`${plan?.user?.email} (${plan?.user?.type})`}</p>
                            </div>
                          </>
                        ) : (
                          "Not Found"
                        )}
                      </div>
                    </td>
                    <td className="plan_tbody_td plan_td">{plan.plan}</td>
                    <td className="plan_tbody_td plan_td">
                      <a
                        href={plan.invoiceLink}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Invoice Link
                      </a>
                    </td>
                    <td className="plan_tbody_td plan_td">
                      {plan.subscription}
                    </td>
                    <td className="plan_tbody_td plan_td">
                      {returnDate(plan?.date)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <h2>No Reports</h2>
        )}
      </div>
    </>
  );
};

export default Invoices;
